module.exports = __webpack_public_path__ + "static/media/workplace2.4bff580e.png";